import React from 'react';

import styled from '@emotion/styled';

const PingdomContainer = styled.span({
  border: 0,
  clip: 'rect(1px, 1px, 1px, 1px)',
  height: 0,
  margin: '-1px',
  overflow: 'hidden',
  padding: 0,
  position: 'absolute',
  width: 0,
});

const Pingdom = () => <PingdomContainer aria-hidden="true">PINGDOM_CANARY_STRING</PingdomContainer>;

export { Pingdom };
export default Pingdom;
